import React from 'react'
import styles from './styles.css'
import { Form, Field } from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Textarea from 'orionsoft-parts/lib/components/fields/Textarea'
import Signers from 'App/components/fields/Signers'
import Viewers from 'App/components/fields/Viewers'
import Tags from 'App/components/fields/Tags'
import Button from 'orionsoft-parts/lib/components/Button'
import fileUpload from 'App/helpers/fields/fileUpload'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import { withRouter } from 'react-router'
import withOrganization from 'App/Decorators/withOrganization'
import getQueryParam from 'orionsoft-parts/lib/helpers/getQueryParam'
import FaUpload from 'react-icons/lib/fa/upload'
import TiInfoOutline from 'react-icons/lib/ti/info-outline'
import MdGroup from 'react-icons/lib/md/group'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import MdInfoOutline from 'react-icons/lib/md/info-outline'
import FaEye from 'react-icons/lib/fa/eye'
import FileBinary from 'react-icons/lib/go/file-binary'
import Fingerprint from 'react-icons/lib/md/fingerprint'
import Face from 'react-icons/lib/md/face'
import FeaSigners from '../../../components/fields/FeaSigners'
import emailValidation from 'App/helpers/validations/emailValidation'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import BioSigners from '../../../components/fields/BioSigners'
import FaceSigners from '../../../components/fields/FaceSigners'
import rutValidation from '../../../helpers/validations/rutValidation'
import ToggleOff from 'react-icons/lib/fa/toggle-off'
import ToggleOn from 'react-icons/lib/fa/toggle-on'
import CloseIcon from 'react-icons/lib/md/close'

@withGraphQL(gql`
  query getOrganizationCostCenters {
    getOrganizationCostCenters {
        name
        code
        description
        enabled
        budget
    }
  }
`)

@withGraphQL(gql`
  query commonSigners {
    commonSigners
  }
`)

@withOrganization
@withMutation(gql`
  mutation createDocument(
    $name: String
    $description: String
    $signers: [SignerInput]
    $viewers: [ViewerInput]
    $feaSigners: [FeaSignerInput]
    $faceSigners: [FaceSignerInput]
    $bioSigners: [BioSignerInput]
    $file: FileInput
    $tags: [String]
    $organization: String
    $isPersonal: Boolean
    $costCenterCode: String
  ) {
    createDocument(
      name: $name
      description: $description
      tags: $tags
      signers: $signers
      viewers: $viewers
      feaSigners: $feaSigners
      faceSigners: $faceSigners
      bioSigners: $bioSigners
      file: $file
      organization: $organization
      isPersonal: $isPersonal
      costCenterCode: $costCenterCode
    ) {
      _id
    }
  }
`)

@withMutation(gql`
  mutation getUserProfile($userEmail: String!) {
    getUserProfile(userEmail: $userEmail) {
      name,
      lastName,
      phone,
      rut
    }
  }
`)

@withMessage
@withRouter
export default class Others extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    createDocument: PropTypes.func,
    getUserProfile: PropTypes.func,
    organization: PropTypes.object,
    getOrganizationCostCenters: PropTypes.object,
    commonSigners: PropTypes.object,
    user: PropTypes.object
  }

  constructor(props) {
    super(props)
    if (this.props.router.location.pathname.endsWith('/me')) {
      this.state = { isPersonal: true }
    } else {
      this.state = { isPersonal: false }
    }
    this.setState({
      contactQuery: '',
      showContactList: false
    })
  }

  @autobind
  async getUserProfile(userEmail) {
    console.log('Llamando a getUserProfile con ' + userEmail)
    const userProfile = await this.props.getUserProfile({ userEmail: userEmail })
    console.log('Me llega profile: ', userProfile)
    return userProfile
  }

  @autobind
  async createDocument() {
    console.log('Create')
    this.setState({ loading: true })
    if (!this.state.costCenterCode &&
      this.props.getOrganizationCostCenters && this.props.getOrganizationCostCenters.length > 0) {
      this.state.costCenterCode = this.props.getOrganizationCostCenters[0].code
    }
    console.log('Seteado costCenter')
    let newFeaSigners = []
    if (this.state.feaSigners) {
      for (let index = 0; index < this.state.feaSigners.length; index++) {
        const feaSigner = this.state.feaSigners[index]
        if (feaSigner.name || feaSigner.email) {
          newFeaSigners.push(feaSigner)
        }
      }
    }

    let newFaceSigners = []
    if (this.state.faceSigners) {
      for (let index = 0; index < this.state.faceSigners.length; index++) {
        const faceSigner = this.state.faceSigners[index]
        if (faceSigner.name || faceSigner.email) {
          newFaceSigners.push(faceSigner)
        }
      }
    }

    let newSigners = []
    if (this.state.signers) {
      for (let index = 0; index < this.state.signers.length; index++) {
        const signer = this.state.signers[index]
        if (signer.email) { newSigners.push(signer) }
      }
    }
    this.state.feaSigners = newFeaSigners
    console.log('newFeaSigners ', newFeaSigners)

    let newBioSigners = []
    if (this.state.bioSigners) {
      for (let index = 0; index < this.state.bioSigners.length; index++) {
        const bioSigner = this.state.bioSigners[index]
        if (bioSigner.name || bioSigner.email) {
          newBioSigners.push(bioSigner)
        }
      }
    }
    this.state.bioSigners = newBioSigners
    console.log('newBioSigners ', newBioSigners);

    var viewers = []
    if (this.state.viewers) {
      viewers = this.state.viewers ? this.state.viewers.filter(element => element.email && element.email !== '') : []
    }
    try {
      // if(viewers.length == 0){
      //   throw new Error('Falta rellenar los campos de Espectadores')
      // }
      const {
        createDocument: { _id: documentId }
      } = await this.props.createDocument(
        {
          name: this.state.name,
          description: this.state.description,
          signers: newSigners,
          feaSigners: this.state.feaSigners,
          faceSigners: newFaceSigners,
          bioSigners: this.state.bioSigners,
          viewers: viewers,
          file: this.state.file,
          tags: this.state.tags,
          organization: this.props.organization._id,
          isPersonal: this.state.isPersonal,
          costCenterCode: this.state.costCenterCode
        },
        {
          refetchQueries: ['getDocument', 'document', 'documents', 'documentCount']
        }
      )
      this.props.router.push(`/sign/prepare/${documentId}`)
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  renderUploadFile() {
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              <h3 className={styles.title}>Carga el documento</h3>
            </div>
            <div className="col-xs-12 col-sm-9 end-md">
              <div className={styles.icon}>
                <FaUpload size={18} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="requireFile isrequired"></div>
          <Field fieldName="file" label="File" {...fileUpload} placeholder="Subir archivo"/>
          <div className='messagePDF'>Puede ser que se generen diferencias en los formatos Word, Excel y PowerPoint. Sugerimos de preferencia que sea en formato PDF</div>
        </div>
      </div>
    )
  }

  /* Contact list */
  removeSelection = () => {
    this.setCentroCostos(null)
  }
  onListInputChange = () => {
    this.setState({contactQuery: document.getElementById('contact-field-centrocostos').value, showContactList: true})
  }
  onListInputReset = () => {
    this.setState({contactQuery: '', showContactList: false})
  }
  onListInputBlur = () => {
    setTimeout(() => {
      if (this.state.contactQuery === '') {
        this.setState({contactQuery: '', showContactList: false})
      }
    }, 500)
  }
  renderCentroDeCostosSelection () {
    if (!this.props.getOrganizationCostCenters) return
    if (this.props.getOrganizationCostCenters && this.props.getOrganizationCostCenters.length > 0) {
      const allData = this.props.getOrganizationCostCenters.map((element) => ({ ...element, fullData: `${element.description} ${element.name}` }))
      return (
        this.state.costCenterCode && this.state.costCenterCode.length > 0 &&
        allData
          .filter(contact => contact.code.includes(this.state.costCenterCode))
          .map(contact => (
            <div key={contact.code} className="selectedcontact">{contact.description.length > 0 && '(' + contact.description + ') '}{contact.name} <span className="" onClick={e => { this.setCentroCostos(null); this.setState({contactQuery: ''}) }}><CloseIcon size={20} /></span></div>
          ))
      )
    }
  }
  renderCentroDeCostosList () {
    if (!this.props.getOrganizationCostCenters || this.state.costCenterCode) return
    if (this.props.getOrganizationCostCenters && this.props.getOrganizationCostCenters.length > 0) {
      const contacts = this.props.getOrganizationCostCenters
      const allData = contacts.map((element) => ({ ...element, fullData: `${element.description} - ${element.name}` }))
      return (
        this.state.contactQuery.length > 0 &&
        allData
          .filter(contact => contact.fullData.toLowerCase().includes(this.state.contactQuery.toLowerCase()))
          .map(contact => (
            <div key={contact.code} className="addcontactbutton" onClick={() => { this.setCentroCostos(contact.code) }} data-searchstring={contact.name}>{contact.description.length > 0 && '(' + contact.description + ') '}{contact.name}<span>Seleccionar</span></div>
          ))
      )
    }
  }
  renderCentroDeCostosSearch() {
    if (this.props.getOrganizationCostCenters && this.props.getOrganizationCostCenters.length > 0) {
      return (
        <div className="cdc-container">
          <div className="label requireCost isrequired">Centro de costos</div>
          <div className={styles.contactlist}>
            {!this.state.costCenterCode && (
              <div className="top">
                <input className="os-input-text" id="contact-field-centrocostos" type="text" value={this.state.contactQuery} onChange={this.onListInputChange} placeholder="Buscar el centro de costos" onFocus={this.onListInputChange} onBlur={this.onListInputBlur}/>
              </div>
            )}
            {this.state.showContactList && (
              <div className="contactListContainer">
                {this.renderCentroDeCostosSelection()}
                {this.renderCentroDeCostosList()}
              </div>
            )}
          </div>
        </div>
      )
    }
  }

  /* Contact list end */

  renderCentroDeCostosOptions() {
    // alert("User " + this.props.user.profile.name)
    if (!this.props.getOrganizationCostCenters) return
    console.log('centros de costo origin', this.props.getOrganizationCostCenters)
    var centrosDeCosto = []
    centrosDeCosto.unshift({
      name: 'Seleccione centro de costo',
      code: '',
      description: ''
    })
    centrosDeCosto = centrosDeCosto.concat(this.props.getOrganizationCostCenters)
    return centrosDeCosto.map(centro => {
      let label = centro.name
      if (centro.description) { label = '(' + centro.description + ') ' + label }
      return <option key={centro.code} value={centro.code}>{label}</option>
    })
  }

  setCentroCostos(centro) {
    // this.state.costCenterCode = centro;
    this.setState({
      costCenterCode: centro
    })
  }

  renderCentroCostos() {
    if (this.props.getOrganizationCostCenters && this.props.getOrganizationCostCenters.length > 0) {
      return (
        <div>
          <br />
          <div className="label requireCost isrequired">Centro de Costo</div>
          <select
            className="col-xs-6 col-sm-6 fileupload"
            value={this.state.packAgregado}
            onChange={event => this.setCentroCostos(event.target.value)}>
            {this.renderCentroDeCostosOptions()}
          </select>
        </div>
      )
    }
  }

  renderSigners() {
    // if (this.props.router.location.pathname.endsWith('/me')) return
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-10">
              <h3 className={styles.title}>Solicitar Firma Simple
                <span className={styles.notification}>&nbsp;
                  <Tooltip
                    content={'Las firmas simples se firman primero que las avanzadas.'}
                  >
                    <MdInfoOutline size={20} className="info-tooltip"/>
                  </Tooltip>
                </span>
              </h3>
            </div>
            <div className="col-xs-12 col-sm-2 end-md">
              <div className={styles.icon}>
                <MdGroup size={20} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <Field
            fieldName="signers"
            type={Signers}
            addMe={getQueryParam('and') === 'me'}
            prepare={true}
            autoAdd={false}
            commonSigners={this.props.commonSigners ? this.props.commonSigners : null}
            getUserProfile={this.getUserProfile}
          />
        </div>
      </div>
    )
  }

  toggleContent (sectionId) {
    const element = document.getElementById(sectionId)
    if (element.getAttribute('data-hidden') === 'true') {
      element.setAttribute('data-hidden', 'false')
    } else {
      element.setAttribute('data-hidden', 'true')
    }
  }

  renderViewers() {
    return (
      <div className="section" id="section-espectadores" data-hidden="true">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-10">
              <h3 className={styles.title}>Espectadores
                <span className='toggleOn'>Ocultar</span>
                <ToggleOn size={30} className="toggle toggleOn" onClick={() => { this.toggleContent('section-espectadores') }} />
                <span className='toggleOff'>Mostrar</span>
                <ToggleOff size={30} className="toggle toggleOff" onClick={() => { this.toggleContent('section-espectadores') }}/>
              </h3>
            </div>
            <div className="col-xs-12 col-sm-2 end-md">
              <div className={styles.icon}>
                <FaEye size={20} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <Field
            fieldName="viewers"
            type={Viewers}
            prepare={true}
            commonSigners={this.props.commonSigners ? this.props.commonSigners : null}
          />
        </div>
      </div>
    )
  }

  renderFacial() {
    console.log('Render Facial')
    // if ( true)   { return null }

    return (
      <div className="section" id="section-facial" data-hidden="true">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-10">
              <h3 className={styles.title}>Solicitar Autenticación Facial ( Opcional )
                <span className={styles.notification}>&nbsp;
                  <Tooltip
                    content={'La autenticación debe ser realizada en el móvil de cada usuario'}
                  >
                    <MdInfoOutline size={20} className="info-tooltip"/>
                  </Tooltip>
                </span>
                <span className='toggleOn'>Ocultar</span>
                <ToggleOn size={30} className="toggle toggleOn" onClick={() => { this.toggleContent('section-facial') }} />
                <span className='toggleOff'>Mostrar</span>
                <ToggleOff size={30} className="toggle toggleOff" onClick={() => { this.toggleContent('section-facial') }}/>
              </h3>
            </div>
            <div className="col-xs-12 col-sm-2 end-md">
              <div className={styles.icon}>
                <Face size={20} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <Field
            fieldName="faceSigners"
            type={FaceSigners}
            prepare={true}
            draggable='false'
            commonSigners={this.props.commonSigners ? this.props.commonSigners : null}
          />
        </div>
      </div>
    )
  }

  renderDactilar() {
    console.log('Render Dactilar')
    if (this.props.organization && this.props.organization.bioServices && this.props.organization.bioServices.dactilar && this.props.organization.bioServices.dactilar.active) {
      return (
        <div className="section" id="section-dactilar" data-hidden="true">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-10">
                <h3 className={styles.title}>Solicitar Autenticación Dactilar ( Opcional )
                  <span className={styles.notification}>&nbsp;
                    <Tooltip
                      content={'La autenticación debe ser realizada en dispositivos biométricos autorizados por tuFirma.digital'}
                    >
                      <MdInfoOutline size={20} className="info-tooltip"/>
                    </Tooltip>
                  </span>
                  <span className='toggleOn'>Ocultar</span>
                  <ToggleOn size={30} className="toggle toggleOn" onClick={() => { this.toggleContent('section-dactilar') }} />
                  <span className='toggleOff'>Mostrar</span>
                  <ToggleOff size={30} className="toggle toggleOff" onClick={() => { this.toggleContent('section-dactilar') }}/>
                </h3>
              </div>
              <div className="col-xs-12 col-sm-2 end-md">
                <div className={styles.icon}>
                  <Fingerprint size={20} />
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <Field
              fieldName="bioSigners"
              type={BioSigners}
              prepare={true}
              draggable='true'
              commonSigners={this.props.commonSigners ? this.props.commonSigners : null}
            />
          </div>
        </div>
      )
    } else {
      // console.log("No dactilar ", this.props.organization);
    }

  }

  renderFeaSigners() {
    return (
      <div className="section" id="section-fea" data-hidden="true">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-10">
              <h3 className={styles.title}>Solicitar Firma Avanzada ( Opcional )
                <span className={styles.notification}>&nbsp;
                  <Tooltip
                    content={'La ley 19.799 establece la firma avanzada como una firma certificada por una entidad acreditada\nante el ministerio de economía. Su característica principal es que tiene el carácter de INOPONIBLE,\nes decir, quien firma no puede desconocer el acto, al igual que la firma ante notario.'}
                  >
                    <MdInfoOutline size={20} className="info-tooltip"/>
                  </Tooltip>
                </span>
                <span className='toggleOn'>Ocultar</span>
                <ToggleOn size={30} className="toggle toggleOn" onClick={() => { this.toggleContent('section-fea') }} />
                <span className='toggleOff'>Mostrar</span>
                <ToggleOff size={30} className="toggle toggleOff" onClick={() => { this.toggleContent('section-fea') }}/>
              </h3>

            </div>
            <div className="col-xs-12 col-sm-2 end-md">
              <div className={styles.icon}>
                <FileBinary size={20} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div>
            Las firmas electrónicas avanzadas se realizarán en el orden que definas.<br/>
            Puedes cambiar el orden de los Firmantes arrastrando a la nueva posicion<p></p>
          </div>
          <Field
            fieldName="feaSigners"
            type={FeaSigners}
            prepare={true}
            draggable='true'
            commonSigners={this.props.commonSigners ? this.props.commonSigners : null}
            getUserProfile={this.getUserProfile}/>
        </div>
      </div>
    )
  }

  checkForm() { // Si true => NO Permite seguir (propiedad disabled del boton Preparar Documento)
    let value = true
    const signersCheck = this.state.signers || []

    let nFirmantes = 0
    let nFeaFirmantes = 0
    let nFaceFirmantes = 0
    for (const signer of signersCheck) {
      if (signer.email && signer.name) { nFirmantes++ }
      if (!signer.email && !signer.name) {
        continue
      }
      if (!signer.email || !emailValidation(signer.email)) {
        value = false
        break
      }
    }

    let feaTest = true
    const feaSignersCheck = this.state.feaSigners || []
    for (const feaSigner of feaSignersCheck) {
      if ((feaSigner.name || feaSigner.email) && !emailValidation(feaSigner.email)) {
        feaTest = false
        break
      }
      if (feaSigner.name) {
        nFeaFirmantes++
      }
    }

    let faceTest = true
    const faceSignersCheck = this.state.faceSigners || []
    for (const faceSigner of faceSignersCheck) {
      if ((faceSigner.name || faceSigner.email) && !emailValidation(faceSigner.email)) {
        faceTest = false
        break
      }
      if (faceSigner.name) {
        nFaceFirmantes++
      }
    }

    let bioTest = true
    let nBioFirmantes = 0
    const bioSignersCheck = this.state.bioSigners || []
    for (const bioSigner of bioSignersCheck) {

      console.log('Validando bioSigner:', bioSigner)
      let validatedRut = rutValidation(bioSigner.rut, bioSigner.pais);
      let validatedEmail = emailValidation(bioSigner.email)
      console.log('validatedRut = ' + validatedRut + ', validatedEmail=' + validatedEmail)
      if (bioSigner.name || bioSigner.email || bioSigner.rut) {
        if (!validatedEmail || !validatedRut) {
          bioTest = false
          break
        }
        nBioFirmantes++
      }
    }

    let sumaFirmantes = nFirmantes + nFeaFirmantes + nBioFirmantes + nFaceFirmantes
    console.log('nFirmantes: ' + nFirmantes + ', nFeaFirmantes ' + nFeaFirmantes + ', nBioFirmantes: ' + nBioFirmantes + ', nFaceFirmantes:' +
        nFaceFirmantes + '.  SumaFirmantes: ' + sumaFirmantes + ', isPersonal: ' + this.state.isPersonal)
    if (!this.state.isPersonal && sumaFirmantes === 0) {
      value = false
    }

    let costCenterTest = false
    if (this.props.getOrganizationCostCenters && this.props.getOrganizationCostCenters.length > 0) {
      console.log('Chequeando centro de costo...')
      if (!this.state.costCenterCode || this.state.costCenterCode.trim === '') { costCenterTest = true }
    }

    console.log('bioTest es ' + bioTest)
    console.log('faceTest es ' + faceTest)
    console.log('costCenterTest es ' + costCenterTest)

    const checkFile = document.querySelector('.requireFile')
    const checkName = document.querySelector('.requireName')
    const checkCost = document.querySelector('.requireCost')
    const msgbox = document.querySelector('.messagePDF')

    const check = (element, data) => {
      if (element) {
        if (data) {
          element.classList.remove('active')
        } else {
          element.classList.add('active')
        }
      }
    }

    const checkmsg = () => {
      if (msgbox) {
        if (this.state.file) {
          if (this.state.file.bool === false) {
            msgbox.style.display = 'block'
          }
        } else {
          msgbox.style.display = 'none'
        }
      }
    }

    const copyName = () => {
      if (this.state.file) {
        if (this.state.name === undefined) {
          this.setState({
            name: this.state.file.nameFile.replace(/([\.][^.]+)?$/, '')
          })
        }
      }
    }

    check(checkFile, this.state.file)
    check(checkName, this.state.name)
    check(checkCost, !costCenterTest)
    checkmsg()
    copyName()

    return !this.state.file || !value || !this.state.name || !feaTest || !bioTest || !faceTest || costCenterTest
  }

  render() {
    console.log('========> Creando documetno')
    return (
      <div className={styles.container}>
        <Form state={this.state} onChange={changes => this.setState(changes)}>
          {this.renderUploadFile()}
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <h3 className={styles.title}>Información del documento</h3>
                </div>
                <div className="col-xs-12 col-sm-8 end-md">
                  <div className={styles.icon}>
                    <TiInfoOutline size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <div className="label requireName isrequired">Nombre</div>
              <Field fieldName="name" placeholder="Nombre" type={Text}/>
              <br />
              <div className="label">Tags (opcional)</div>
              <div className=""><small>Escribe el texto que quieres usar como etiqueta de este documento y luego presiona <i>Enter</i> para activarla.</small></div>
              <Field fieldName="tags" placeholder="Tags" type={Tags} />
              <br />
              <div className="label">Descripción (opcional)</div>
              <Field
                fieldName="description"
                placeholder="Descripción"
                type={Textarea}
              />
              <br />
              {this.renderCentroDeCostosSearch()}
            </div>
          </div>
          {this.renderSigners()}
          {this.renderFeaSigners()}
          {
            // this.renderFacial()
          }
          {this.renderDactilar()}
          {this.renderViewers()}
        </Form>
        <div className="right-align">
          <Button
            disabled={this.checkForm()}
            loading={this.state.loading}
            primary
            onClick={this.createDocument}
          >
            Preparar el documento
          </Button>
        </div>
        <br />
        <br />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Create/index.js